// initialCheck();

// function initialCheck(){
//     console.log('checking if its working');
// }

// document.addEventListener("DOMContentLoaded", () => {
//     const fieldSet = document.querySelector("#picker_gloradiance");
//     console.log(fieldSet.id);
    
//     const pickers = fieldSet.querySelectorAll("input");

//     console.log(pickers);
//     pickers.forEach(input => {
//         input.addEventListener("change", () => {
//             console.log("Connector changed to:", input.value);
//             onConnectorChange(input.value, "Connecter");
//         });

//         //for default Text
//         if(input.checked == true){
//             inActionTextChange(input.value);
//         }
//     });
    

// });

// function inActionTextChange(textValue){
//     var inActionText = document.querySelector('.gallery-title');
//     var inActionText2 = document.querySelector('.gallery-title2');
//     inActionText.innerHTML = textValue + " in Action";
//     inActionText2.innerHTML = textValue + " in Action";
// }

// function onConnectorChange(connectorValue, variant) {
//   console.log("Connector changed to:", connectorValue);
//   console.log("Full variant:", variant);
//   inActionTextChange(connectorValue);
// }

//working but complicated
(function () {
  // CONFIG: change this if your connector input name differs
  const CONNECTOR_NAME_PREFIX = "Connector"; // matches inputs like name="Connector-1"
  const DEBOUNCE_MS = 50;

  // state
  let lastConnectorValue = null;
  let debounceTimer = null;

  function log(...args) {
    // set to false to silence
    const ENABLE = true;
    if (ENABLE) console.log('[connector-detector]', ...args);
  }

  // read current connector value from DOM (returns null if not found)
  function readCurrentConnectorValue() {
    // try to select checked input with name starting with CONNECTOR_NAME_PREFIX
    // attribute selector for name^=
    const selector = 'input[type="radio"][name^="' + CONNECTOR_NAME_PREFIX + '"]:checked';
    const checked = document.querySelector(selector);
    if (checked) return checked.value;
    // fallback: maybe select one that has data-option-value or other attribute
    const any = document.querySelector('input[type="radio"][name^="' + CONNECTOR_NAME_PREFIX + '"]');
    return any ? any.value : null;
  }

  // the handler you want to run when connector changes
  function onConnectorChange(newVal) {
    log('onConnectorChange fired, new value:', newVal);
    // Put your logic here. Example: update gallery titles
    const t1 = document.querySelector('.gallery-title');
    const t2 = document.querySelector('.gallery-title2');
    if (t1) t1.innerHTML = newVal + " in Action";
    if (t2) t2.innerHTML = newVal + " in Action";

    // (Optional) If you need to swap images, call a function here.
    swapGalleryForConnector(newVal);
    swapLifeStylePhotos(newVal);
  }

  // internal: call when we think connector might have changed
  function maybeFireConnectorChange() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const current = readCurrentConnectorValue();
      if (current === null) {
        log('No connector input found on page.');
        return;
      }
      if (current !== lastConnectorValue) {
        log('Connector value changed from', lastConnectorValue, 'to', current);
        lastConnectorValue = current;
        onConnectorChange(current);
      } else {
        log('Connector unchanged:', current);
      }
    }, DEBOUNCE_MS);
  }

  // 1) Delegated change listener on document for radio inputs (survives DOM replacements)
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;
    if (t.matches && t.matches('input[type="radio"][name^="' + CONNECTOR_NAME_PREFIX + '"]')) {
      log('document change event for connector input detected:', t.value);
      // update state and fire
      maybeFireConnectorChange();
    }
  }, true); // use capture to catch early

  // 2) Listen for clicks anywhere (some UIs change variant on click without change event)
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t) return;
    // if a label or input for connector clicked, check after tiny delay
    if (t.matches('label') && t.htmlFor && document.getElementById(t.htmlFor)) {
      const related = document.getElementById(t.htmlFor);
      if (related && related.matches('input[type="radio"][name^="' + CONNECTOR_NAME_PREFIX + '"]')) {
        log('label click for connector detected');
        maybeFireConnectorChange();
      }
    } else if (t.matches('input[type="radio"][name^="' + CONNECTOR_NAME_PREFIX + '"]')) {
      log('click on connector input detected');
      maybeFireConnectorChange();
    }
  }, true);

  // 3) Robust URL/history change detection (catches Dawn AJAX variant updates that change ?variant=)
  (function(history) {
    const pushState = history.pushState;
    const replaceState = history.replaceState;
    history.pushState = function() {
      const res = pushState.apply(history, arguments);
      window.dispatchEvent(new Event('historychange'));
      return res;
    };
    history.replaceState = function() {
      const res = replaceState.apply(history, arguments);
      window.dispatchEvent(new Event('historychange'));
      return res;
    };
  })(window.history);

  window.addEventListener('popstate', () => {
    log('popstate event');
    maybeFireConnectorChange();
  });

  window.addEventListener('historychange', () => {
    log('history change event');
    // small delay to allow DOM updates from Dawn
    setTimeout(maybeFireConnectorChange, 40);
  });

  // 4) On initial load, set baseline
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      lastConnectorValue = readCurrentConnectorValue();
      log('initial connector value:', lastConnectorValue);
      // run initial action if desired
      if (lastConnectorValue !== null) onConnectorChange(lastConnectorValue);
    }, 30);
  });

  // Also guard for theme editor/section reloads
  window.addEventListener('shopify:section:load', maybeFireConnectorChange);
  window.addEventListener('shopify:section:reorder', maybeFireConnectorChange);
  window.addEventListener('shopify:section:unload', maybeFireConnectorChange);
})();




//---------------------------------------------------------
// IMAGE SWAP HANDLER — triggered when connector changes
//---------------------------------------------------------

function swapGalleryForConnector(connectorValue) {
  console.log("[swapGallery] connector:", connectorValue);

  const galleryWrapper = document.querySelector(".gallery-wrapper");
  if (!galleryWrapper) return;

  const variantImages = window.variantImages || [];

  let matchedVariant = null;

  variantImages.forEach(block => {
    block.variants.forEach(v => {
      if (v.name.toString().trim().toLowerCase() === connectorValue.toString().trim().toLowerCase()) {
        matchedVariant = v;
      }
    });
  });

  if (!matchedVariant) {
    console.log("[swapGallery] No matching variant found → fallback to product media.");
    resetToDefaultGallery();
    return;
  }

  const imgs = matchedVariant.images || [];
  if (imgs.length === 0) {
    console.log("[swapGallery] Variant has no images → fallback to product media.");
    resetToDefaultGallery();
    return;
  }

  //---------------------------------------------------------
  // BUILD NEW THUMBNAILS
  //---------------------------------------------------------
  const thumbGrid = document.querySelector(".thumb-grid");
  thumbGrid.innerHTML = ""; // wipe

  imgs.forEach((img, index) => {
    const img300 = img.img_url + "&width=300";
    const img1200 = img.img_url + "&width=1200";

    const thumbBox = document.createElement("div");
    thumbBox.className = "thumb-box";

    const thumbImg = document.createElement("img");
    thumbImg.className = "thumb-img" + (index === 0 ? " active-thumb" : "");
    thumbImg.src = img300;
    thumbImg.dataset.full = img1200;

    // click handler
    thumbImg.addEventListener("click", () => {
      swapMainImage(img1200);
      document.querySelectorAll(".thumb-img")
        .forEach(t => t.classList.remove("active-thumb"));
      thumbImg.classList.add("active-thumb");
    });

    thumbBox.appendChild(thumbImg);
    thumbGrid.appendChild(thumbBox);
  });

  //---------------------------------------------------------
  // SET MAIN IMAGE
  //---------------------------------------------------------
  const firstFull = imgs[0].img_url + "&width=1200";
  swapMainImage(firstFull);
}


//---------------------------------------------------------
// SMOOTH MAIN IMAGE SWAP
//---------------------------------------------------------
function swapMainImage(newSrc) {
  const main = document.querySelector("#MainGalleryImage");
  if (!main) return;

  const temp = new Image();
  temp.src = newSrc;

  temp.onload = () => {
    main.style.opacity = 0;
    setTimeout(() => {
      main.src = newSrc;
      main.style.opacity = 1;
    }, 150);
  };
}


//---------------------------------------------------------
// FALLBACK: Use Shopify product.media
//---------------------------------------------------------
function resetToDefaultGallery() {
  console.log("[swapGallery] Resetting to default product gallery");

  const thumbs = document.querySelectorAll(".thumb-img");
  if (thumbs.length === 0) return;

  const first = thumbs[0];
  const main = document.querySelector("#MainGalleryImage");

  // reset main
  main.src = first.dataset.full;

  // reset active state
  document.querySelectorAll(".thumb-img")
    .forEach(t => t.classList.remove("active-thumb"));

  first.classList.add("active-thumb");
}

function swapLifeStylePhotos(newVal){
    const lf1 = document.getElementById("lf1");
    const lf2 = document.getElementById("lf2");

    if(newVal == 'Quick Release'){
        lf1.style.display = "block";
        lf2.style.display = "none";
    }

    if(newVal == 'QuickFit'){
        lf2.style.display = "block";
        lf1.style.display = "none";
    }
}

